export default "/icons/slack_icon.svg";